import React from 'react'
import {
  CCol,
  CFormLabel,
  CFormSelect,
  CFormInput,
  CFormFeedback,
  CInputGroup,
  CInputGroupText,
  CRow,
} from '@coreui/react-pro'
import InfoTooltip from './InfoTooltip'

const TEAM_SIZE_OPTIONS = [6, 7, 8, 9, 10, 11]

const TeamBudget = ({ values, errors, touched, onChange, disabled, currencySymbol = '$' }) => (
  <CRow className="g-3">
    <CCol md={4}>
      <CFormLabel className="fw-bold d-flex align-items-center" htmlFor="team_size">
        Team Size (Players)
        <InfoTooltip content="The number of players each member must select to build their fantasy team." />
      </CFormLabel>
      <CFormSelect
        id="team_size"
        name="team_size"
        value={values.team_size}
        onChange={(e) => onChange('team_size', e.target.value)}
        disabled={disabled}
        className={errors.team_size && touched.team_size ? 'is-invalid' : ''}
      >
        <option value="">Select Team Size</option>
        {TEAM_SIZE_OPTIONS.map((size) => (
          <option key={size} value={size}>
            {size} Players
          </option>
        ))}
      </CFormSelect>
    </CCol>

    <CCol md={4}>
      <CFormLabel className="fw-bold d-flex align-items-center" htmlFor="salary_cap">
        Salary Cap
        <InfoTooltip content="The total budget each member has to spend when picking their fantasy team." />
      </CFormLabel>
      <CInputGroup className={errors.salary_cap && touched.salary_cap ? 'is-invalid' : ''}>
        <CInputGroupText>{currencySymbol}</CInputGroupText>
        <CFormInput
          id="salary_cap"
          name="salary_cap"
          type="number"
          min={50}
          max={150}
          value={values.salary_cap}
          onChange={(e) => onChange('salary_cap', e.target.value)}
          disabled={disabled}
          className={errors.salary_cap && touched.salary_cap ? 'is-invalid' : ''}
        />
        <CInputGroupText>million</CInputGroupText>
        {errors.salary_cap && touched.salary_cap && (
          <CFormFeedback invalid>{errors.salary_cap}</CFormFeedback>
        )}
      </CInputGroup>
    </CCol>

    <CCol md={4}>
      <CFormLabel className="fw-bold d-flex align-items-center" htmlFor="trades">
        Total Trades
        <InfoTooltip content="The number of player trades a member is allowed to make across the season." />
      </CFormLabel>
      <CInputGroup className={errors.trades && touched.trades ? 'is-invalid' : ''}>
        <CFormInput
          id="trades"
          name="trades"
          type="number"
          min={0}
          max={100}
          value={values.trades}
          onChange={(e) => onChange('trades', e.target.value)}
          className={errors.trades && touched.trades ? 'is-invalid' : ''}
        />
        <CInputGroupText>trades</CInputGroupText>
        {errors.trades && touched.trades && <CFormFeedback invalid>{errors.trades}</CFormFeedback>}
      </CInputGroup>
    </CCol>
  </CRow>
)

export default TeamBudget
